import { __awaiter } from "tslib";
import { castToInteger } from '../utils/cast-to-integer';
export default function handleApiPrompt(world, type, data) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (type) {
            case 'run':
                yield handleRun(world, data);
                return world.toApiJson();
            case 'runAll':
                yield handleRunAll(world);
                return world.toApiJson();
            case 'getState':
                return world.toApiJson();
        }
    });
}
function handleRun(world, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return world.run(Math.max(1, castToInteger(data.steps, 1)));
    });
}
function handleRunAll(world) {
    return __awaiter(this, void 0, void 0, function* () {
        return world.runAll();
    });
}
function handleGetMap(world) {
    return __awaiter(this, void 0, void 0, function* () {
        const map = world.levelMap;
        if (!map) {
            throw new Error('No map');
        }
        return map.toApiJson();
    });
}
